import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const ReplaceCircleIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
          fill="black"
          fill-opacity="0.87"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18 9.17234L14.9277 6V8.28627H8.35604V10.0584H9.07228H14.9277V12.3447L18 9.17234ZM15.644 13.9416H14.9277H9.07228V11.6553L6 14.8277L9.07228 18V15.7137H15.644V13.9416Z"
          fill="white"
        />
      </svg>
    )
  },
)
